const SmileIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M1.6665 15.9993C1.6665 8.08327 8.08376 1.66602 15.9998 1.66602C23.9159 1.66602 30.3332 8.08327 30.3332 15.9993C30.3332 23.9154 23.9159 30.3327 15.9998 30.3327C8.08376 30.3327 1.6665 23.9154 1.6665 15.9993Z"
        fill="#FF0000"
      />
      <path
        d="M11.4663 19.3992C11.1346 18.9576 10.5078 18.8685 10.0662 19.2001C9.62458 19.5318 9.53546 20.1587 9.86713 20.6003C11.264 22.4602 13.4913 23.6664 16.0001 23.6664C18.5088 23.6664 20.7361 22.4602 22.133 20.6003C22.4647 20.1587 22.3755 19.5318 21.9339 19.2001C21.4923 18.8685 20.8655 18.9576 20.5338 19.3992C19.4984 20.7778 17.8531 21.6664 16.0001 21.6664C14.147 21.6664 12.5017 20.7778 11.4663 19.3992Z"
        fill="#FF0000"
      />
      <path
        d="M10.6667 10.333C9.74619 10.333 9 11.0792 9 11.9997C9 12.9202 9.74619 13.6663 10.6667 13.6663H10.6786C11.5991 13.6663 12.3453 12.9201 12.3453 11.9997C12.3453 11.0792 11.5991 10.333 10.6786 10.333H10.6667Z"
        fill="#FF0000"
      />
      <path
        d="M21.3214 10.333C20.4009 10.333 19.6547 11.0792 19.6547 11.9997C19.6547 12.9201 20.4009 13.6663 21.3214 13.6663H21.3333C22.2538 13.6663 23 12.9201 23 11.9997C23 11.0792 22.2538 10.333 21.3333 10.333H21.3214Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export default SmileIcon;
